import { useParams } from "react-router";

export const useConversationIdRouteParams = () => {
    const { conversationId } = useParams<{ conversationId: string }>();

    if (!conversationId) {
        throw new Error("conversationId is missing in route params");
    }

    return { conversationId };
};
